import React from "react";
import { Link } from "react-router-dom";

const HomeCTA = () => {
  return (
    <section className="bg-[#fbf7ee] border-t border-[#eae1c4]">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-24 text-center">
        <div className="flex items-center justify-center gap-4 mb-6">
          <span className="block h-px w-40 bg-[#c9a961]"></span>
          <span className="text-[#c9a961]">†</span>
          <span className="block h-px w-40 bg-[#c9a961]"></span>
        </div>
        <h2
          className="font-display text-[#1e2952] text-[32px] md:text-[42px] lg:text-[48px] leading-[1.1]"
          style={{ fontWeight: 500 }}
        >
          Become a Founding Family.
        </h2>
        <p className="font-serif-body text-[#3a466e] text-[17px] md:text-[18px] leading-[1.75] max-w-[720px] mx-auto mt-6">
          Join a community of families seeking a faithful Catholic education
          rooted in the liberal arts, a robust &amp; beautiful Humanities program,
          and a joyful school culture.
        </p>
        <div className="mt-10 flex justify-center">
          <Link
            to="/inquire"
            className="btn-navy font-sans-nav text-[13px] tracking-[0.28em] uppercase px-12 py-5"
          >
            Inquire Today
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeCTA;
